var map = {
	"./analytics-circle.svg": "../svg-icons/analytics-circle.svg",
	"./arrow-down.svg": "../svg-icons/arrow-down.svg",
	"./checkbox.svg": "../svg-icons/checkbox.svg",
	"./icon-arrow-down.svg": "../svg-icons/icon-arrow-down.svg",
	"./icon-arrow-left.svg": "../svg-icons/icon-arrow-left.svg",
	"./icon-arrow-right.svg": "../svg-icons/icon-arrow-right.svg",
	"./icon-arrow-up.svg": "../svg-icons/icon-arrow-up.svg",
	"./icon-burger-menu.svg": "../svg-icons/icon-burger-menu.svg",
	"./icon-business.svg": "../svg-icons/icon-business.svg",
	"./icon-calendar.svg": "../svg-icons/icon-calendar.svg",
	"./icon-charity.svg": "../svg-icons/icon-charity.svg",
	"./icon-chevron-bottom.svg": "../svg-icons/icon-chevron-bottom.svg",
	"./icon-chevron-left.svg": "../svg-icons/icon-chevron-left.svg",
	"./icon-chevron-right.svg": "../svg-icons/icon-chevron-right.svg",
	"./icon-circled-play.svg": "../svg-icons/icon-circled-play.svg",
	"./icon-close.svg": "../svg-icons/icon-close.svg",
	"./icon-development_skill.svg": "../svg-icons/icon-development_skill.svg",
	"./icon-doc.svg": "../svg-icons/icon-doc.svg",
	"./icon-document.svg": "../svg-icons/icon-document.svg",
	"./icon-document_transparent.svg": "../svg-icons/icon-document_transparent.svg",
	"./icon-document_writer.svg": "../svg-icons/icon-document_writer.svg",
	"./icon-download.svg": "../svg-icons/icon-download.svg",
	"./icon-ecology.svg": "../svg-icons/icon-ecology.svg",
	"./icon-email_document.svg": "../svg-icons/icon-email_document.svg",
	"./icon-external-link.svg": "../svg-icons/icon-external-link.svg",
	"./icon-filter.svg": "../svg-icons/icon-filter.svg",
	"./icon-graduation_cap.svg": "../svg-icons/icon-graduation_cap.svg",
	"./icon-graph.svg": "../svg-icons/icon-graph.svg",
	"./icon-head.svg": "../svg-icons/icon-head.svg",
	"./icon-high-risk.svg": "../svg-icons/icon-high-risk.svg",
	"./icon-location.svg": "../svg-icons/icon-location.svg",
	"./icon-manager.svg": "../svg-icons/icon-manager.svg",
	"./icon-merchant_account.svg": "../svg-icons/icon-merchant_account.svg",
	"./icon-money_yours.svg": "../svg-icons/icon-money_yours.svg",
	"./icon-news.svg": "../svg-icons/icon-news.svg",
	"./icon-oil-industry.svg": "../svg-icons/icon-oil-industry.svg",
	"./icon-oil-pump.svg": "../svg-icons/icon-oil-pump.svg",
	"./icon-pdf.svg": "../svg-icons/icon-pdf.svg",
	"./icon-protect.svg": "../svg-icons/icon-protect.svg",
	"./icon-quote.svg": "../svg-icons/icon-quote.svg",
	"./icon-reserve.svg": "../svg-icons/icon-reserve.svg",
	"./icon-sad.svg": "../svg-icons/icon-sad.svg",
	"./icon-search.svg": "../svg-icons/icon-search.svg",
	"./icon-smiley.svg": "../svg-icons/icon-smiley.svg",
	"./icon-sport.svg": "../svg-icons/icon-sport.svg",
	"./icon-transaction.svg": "../svg-icons/icon-transaction.svg",
	"./icon-trophy.svg": "../svg-icons/icon-trophy.svg",
	"./icon-unavailable--default.svg": "../svg-icons/icon-unavailable--default.svg",
	"./icon-unavailable.svg": "../svg-icons/icon-unavailable.svg",
	"./icon-update-left-rotation.svg": "../svg-icons/icon-update-left-rotation.svg",
	"./icon-users_settings.svg": "../svg-icons/icon-users_settings.svg",
	"./icon-video.svg": "../svg-icons/icon-video.svg",
	"./icon-worker.svg": "../svg-icons/icon-worker.svg",
	"./link-arrow.svg": "../svg-icons/link-arrow.svg",
	"./map-arrow.svg": "../svg-icons/map-arrow.svg",
	"./map-icon.svg": "../svg-icons/map-icon.svg",
	"./map-icon_en.svg": "../svg-icons/map-icon_en.svg",
	"./russneft-logo-en.svg": "../svg-icons/russneft-logo-en.svg",
	"./russneft-logo.svg": "../svg-icons/russneft-logo.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "../svg-icons sync \\.svg$";